// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"UserRelationshipTable_deleteButton__1Xlbp"};